// Business / School yönlendirmeleri: her ekran modül izni (+ varsa özellik bayrağı) ile korunur.
import { businessCommercialRoutes } from './commercial/routes';
import { businessCoreRoutes } from './core/routes';
import { businessQualityRoutes } from './quality/routes';
import { businessReportsRoutes } from './reports/routes';

export const businessRoutes = (
  <>
    {businessCoreRoutes}
    {businessCommercialRoutes}
    {businessQualityRoutes}
    {businessReportsRoutes}
  </>
);
